import {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper, InputTextAreaWrapper} from '../../../../../../components/UI/Form/Input'
import {getServiceById} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {ServiceModel} from '../../../../model'
import {TITLE_FORM_SERVICE} from '../../../../util/Constants'
import {initValues} from '../../../../util/values/service'
import {useTableMaster} from '../../../../hooks'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
const Service: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useLavanderia()
  const {
    typeAdmin,
    typeClothe,
    typeLaundryOrder,
    statusService,
    getStatusServiceList,
    getTypeClotheList,
    getTypeAdminList,
    getTypeLaundryOrderList,
  } = useTableMaster()
  const getServiceByIdValues = async () => {
    const response = await getServiceById(currentTabItem.idToEdit)
    const data = response.data.data
    type ServiceModelKeys = keyof ServiceModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as ServiceModelKeys]) {
            if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as ServiceModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as ServiceModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as ServiceModelKeys])
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }

  useEffect(() => {
    getStatusServiceList()
    getTypeClotheList()
    getTypeAdminList()
    getTypeLaundryOrderList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getServiceByIdValues()
    }
  }, [currentTabItem.idToEdit])

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_SERVICE}>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper labelText='Tipo de ropa' name='tipoRopaId' data={typeClothe} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Administrador del servicio'
            name='tipoAdministracion'
            data={typeAdmin}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de Orden'
            name='tipoOrdenLavadoId'
            data={typeLaundryOrder}
          />
        </div>
        {isDisabled && (
          <div className='col-sm-12 col-lg-3'>
            <SelectWrapper labelText='Estado' name='estado' data={statusService} />
          </div>
        )}
      </div>
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <InputTextAreaWrapper
            labelText='Descripción del servicio'
            name='descripcion'
            textPlaceholder='Escribe la descripción'
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Service
